export const statuses = [
  { value: 'Pending', name: 'Pending' },
  { value: 'Approved', name: 'Approved' },
  { value: 'Rejected', name: 'Rejected' },
]

export const leavetypes = [
  { value: 'Sick', name: 'Sick' },
  { value: 'Normal', name: 'Normal' },
]

export const leavedurations = [
  { value: 'Full Day', name: 'Full Day' },
  { value: 'Half Day', name: 'Half Day' },
  { value: 'Multiple days', name: 'Multiple Days' },
]
